import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'section2',
    templateUrl: './section2.html',
    styleUrls: ['./section2.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, RouterLink, NgClass]
})
export class Section2Component {
    @Input()
    icon?: string;
    @Input()
    title?: string;
    @Input()
    subtitle?: string;
    @Input()
    link?: string;
    @Input()
    linkCopy?: string;
}
